
import { makeStyles, darken, lighten } from '@material-ui/core/styles';


const getWarningBackgroundColor = (
  severity,
  theme,
) => {
  switch (severity) {
    case 'success':
      return theme.palette.success.backgroundSoft;
    case 'info':
      return theme.palette.info.backgroundSoft;
    case 'error':
      return theme.palette.error.backgroundSoft;
    case 'warning':
    default:
      return theme.palette.warning.backgroundSoft;
  }
};

const getWarningBorderColor = (
  severity,
  theme,
) => {
  switch (severity) {
    case 'success':
      return theme.palette.success.main;
    case 'info':
      return theme.palette.info.main;
    case 'error':
      return theme.palette.error.dark;
    case 'warning':
    default:
      return theme.palette.warning.dark;
  }
};

export const useAlertStyles = makeStyles(
  theme => ({
    panel: {
      backgroundColor: ({ severity }) =>
        getWarningBackgroundColor(
          severity ,
          theme,
        ),
      color: ({ severity }) =>
        getWarningTextColor(
          severity ,
          theme,
        ),
      border: ({ severity }) =>
        `1px solid ${getWarningBorderColor(
          severity ,
          theme,
        )}`,
      verticalAlign: 'middle',
      borderRadius: 8,
    },
    summary: {
      display: 'flex',
      flexDirection: 'row',
    },
    summaryText: {
      color: ({ severity }) =>
        getWarningTextColor(
          severity ,
          theme,
        ),
      fontWeight: 'bold',
    },
    text: {
      width: '100%',
      display: 'block',
      color: theme.palette.text.primary,
    },
    details: {
      width: '100%',
      display: 'block',
      color: theme.palette.textContrast,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.border}`,
      padding: theme.spacing(2.0),
      fontFamily: 'sans-serif',
    },
    innerContainer: {
      width: '100%',
      display: 'block',
      color: theme.palette.textContrast,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
  }),
  { name: 'BackstageWarningPanel' },
);

export const getWarningTextColor = (
  severity,
  theme,
) => {
  const getColor = theme.palette.type === 'light' ? darken : lighten;
  return getColor(theme.palette[severity].light, 0.6);
};

export const useErrorOutlineStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1),
    fill: ({ severity }) =>
      getWarningBorderColor(
        severity ,
        theme,
      ),
  },
}));
